import React from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

const RevenueChart: React.FC = () => {
  const options: ApexOptions = {
    chart: {
      type: 'area',
      height: 350,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    colors: ['#0ea5e9', '#8b5cf6'],
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 90, 100],
      },
    },
    xaxis: {
      categories: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      labels: {
        style: {
          colors: '#6b7280',
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: '#6b7280',
          fontSize: '12px',
        },
        formatter: (value) => {
          return `$${(value / 1000000).toFixed(1)}M`;
        },
      },
    },
    grid: {
      borderColor: '#e5e7eb',
      strokeDashArray: 4,
    },
    tooltip: {
      theme: 'light',
      y: {
        formatter: (value) => {
          return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 0,
          }).format(value);
        },
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      fontSize: '14px',
      fontFamily: 'inherit',
      labels: {
        colors: '#374151',
      },
    },
  };

  const series = [
    {
      name: 'Ingresos 2025',
      data: [2100000, 2800000, 3200000, 2900000, 4100000, 3800000, 4500000, 4200000, 3900000, 4800000, 5200000, 5500000],
    },
    {
      name: 'Ingresos 2024',
      data: [1800000, 2200000, 2600000, 2400000, 3200000, 3000000, 3500000, 3300000, 3100000, 3800000, 4100000, 4300000],
    },
  ];

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h3 className="text-xl font-bold text-gray-800 mb-4">Ingresos Mensuales</h3>
      <Chart options={options} series={series} type="area" height={300} />
    </div>
  );
};

export default RevenueChart;
